import { IPropertyDetail } from '../../interfaces/src'

export type PortalKey =
  | 'I24'
  | 'M3'
  | 'CyT'
  | 'PROPIEDADESCOM'
  | 'LAMUDI'
  | 'ALLPROPERTY'
  | 'ELINFORMADOR'
  | 'WIGGOT'
  | 'MONOPOLIO'
  | 'PORTALTERRENOCOM'
  | 'EXCELSIOR'
  | 'BELETA'

export const PORTAL_NAME = {
  I24: 'Inmuebles 24',
  M3: 'MercadoLibre',
  BELETA: 'Beleta',
  CyT: 'Casas y Terrenos',
  CyTLEASE: 'Casas y Terrenos Renta',
  PROPIEDADESCOM: 'Propiedades.com',
  LAMUDI: 'Proppit by Lamudi',
  ALLPROPERTY: 'AllProperty',
  ELINFORMADOR: 'El Informador',
  WIGGOT: 'Wiggot',
  MONOPOLIO: 'Monopolio',
  PORTALTERRENOCOM: 'Portal Terreno.com',
  EXCELSIOR: 'Excelsior'
}

export const assignedLinkToPortalByProperty = ({
  property,
  portalName
}: {
  property: IPropertyDetail
  portalName: string
}): string | null => {
  const assignedLinkByPortal: { [key in string]: string | undefined } = {
    i24: property?.portalI24Link,
    m3: property?.portalM3Link,
    cyt: property?.portalCytLink,
    propiedadescom: property?.portalPropiedadescomLink,
    lamudi: property?.portalLamudiLink,
    allproperty: property?.portalAllPropertyLink,
    elinformador: property?.portalElinformadorLink,
    excelsior: property?.portalExcelsiorLink,
    wiggot: property?.portalWiggotLink,
    monopolio: property?.portalMonopolioLink,
    portalterrenocom: property?.portalPortalterrenocomLink
  }

  return assignedLinkByPortal?.[portalName?.toLowerCase()] ?? null
}
